<script setup>
import { iconHref } from "~/utils/icons.js";

defineProps({
  placeholder: { default: "Search", type: String }
});

const model = defineModel({ default: "", type: String });
const emit = defineEmits(["search"]);

function onSubmit() {
  emit("search");
}
</script>

<template>
  <form class="gl-search-box-by-click gl-search-box-by-click-with-search-button" @submit.prevent="onSubmit">
    <input
      v-model="model"
      type="search"
      :placeholder="placeholder"
      :aria-label="placeholder"
      data-testid="search-input"
      class="gl-form-input gl-search-box-by-click-input"
      @keydown.enter.prevent="onSubmit"
    />
    <button type="submit" data-testid="search-button" aria-label="Search" class="gl-search-box-by-click-search-button">
      <svg class="h-4 w-4" aria-hidden="true" fill="currentColor">
        <use :href="iconHref('search')" />
      </svg>
    </button>
  </form>
</template>
